import script from './Credentials.vue2.js';
import normalizeComponent from '../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "columns is-variable is-multiline is-1 px-0 pt-0 pb-4" },
      [
        _c(
          "div",
          { staticClass: "column pb-0" },
          [
            _c("EmailInput", {
              attrs: {
                label: "Email",
                invalidEmails: _vm.invalidEmails,
                disabled: _vm.disableEmailField || _vm.disabled,
                placeholder:
                  "Email" + (_vm.isEmailOptional ? " (optional)" : ""),
                userID: _vm.userID
              },
              on: { setIsEmailValid: _vm.setIsEmailValid },
              model: {
                value: _vm.info.email,
                callback: function($$v) {
                  _vm.$set(_vm.info, "email", $$v);
                },
                expression: "info.email"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column pb-0" },
          [
            _c("PhoneNumberInput", {
              attrs: {
                "data-testid": "phoneNumber",
                countryCode: _vm.countryCode,
                phoneNumber: _vm.phoneNumber,
                placeholder:
                  "Phone number" + (_vm.isPhoneOptional ? " (optional)" : ""),
                label: "Phone",
                disabled: _vm.disabled
              },
              on: { update: _vm.updatedPhoneNumber }
            })
          ],
          1
        )
      ]
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
